import mainSelect from "@/components/main-select/index.vue";
import { mapActions, mapGetters, mapMutations } from "vuex";
import { required } from "vuelidate/lib/validators";
import { validationMixin } from "vuelidate";

export default {
    name: "agent-client-data",
    mixin: [validationMixin],
    data() {
        return {
            findClient: [],
            pickedClient: "",
            validationErrors: {},
            payload: {
                name: "",
                second_name: "",
                phone: "",
                city: "",
                street: "",
                house: "",
                flat: "",
                email: "",
                agent_client_id: "",
                contact_person_name: "",
                contact_person_phone: "",
                form_of_management: "",
                full_legal_name: "",
                ipn: "",
            },
        };
    },
    validations() {
        return {
            pickedClient: {
                required,
            },
        };
    },

    components: {
        mainSelect,
    },
    watch: {
        pickedClient(value) {
            // let currentId = value.slice(0, value.indexOf(' '))
            this.setDataClient();
        },
    },
    computed: {
        ...mapGetters({
            user: "profile/user",
            agentClients: "profile/agentClients",
        }),
        pickedClientErrors() {
            let error = [];
            if (!this.$v.pickedClient.$dirty) {
                return error;
            }
            if (!this.$v.pickedClient.required) {
                error.push(this.$t("validationRequired"));
            }
            if (this.validationErrors.name) {
                this.validationErrors.pickedClient.forEach(row => {
                    error.push(row);
                });
            }
            return error;
        },
        getClients() {
            const clients = [];
            let data = "";
            for (let i in this.agentClients) {
                if (this.agentClients[i].type === 1) {
                    data =
                        "ФОП" +
                        " " +
                        this.agentClients[i].name +
                        " " +
                        this.agentClients[i].second_name +
                        " " +
                        this.agentClients[i].phone;
                } else {
                    data =
                        "Юр. особа" +
                        " " +
                        this.agentClients[i].full_legal_name +
                        " " +
                        this.agentClients[i].contact_person_name +
                        " " +
                        this.agentClients[i].contact_person_phone;
                }

                clients.push(data);
                // console.log('test', this.agentClients[i].id)
            }
            return clients;
        },
    },
    created() {
        this.fetchAgentClients();
    },
    methods: {
        ...mapMutations({
            changeUserInfo: "order/CHANGE_USER_INFO",
            changeStep: "order/CHANGE_STEP_BUY_FLOW",
        }),
        ...mapActions({
            fetchAgentClients: `profile/GET_AGENT_CLIENTS`,
            fetchFilial: `deliveryMethods/GET_DELIVERY_FILIAL`,
        }),
        submit() {
            this.$v.$touch();
            if (!this.$v.$invalid) {
                this.fetchFilial();
                this.changeUserInfo(this.payload);
                this.changeStep();
            }
        },
        setDataClient() {
            this.payload.email = this.user.email;
            this.payload.phone = this.user.phone;
            this.payload.name = this.user.name;
            this.payload.second_name = this.user.second_name;
            this.agentClients.forEach(client => {
                if (this.pickedClient.includes(client.phone)) {
                    this.payload.agent_client_id = parseInt(client.id);
                }
            });
        },
    },
};
